<template>
  <div class="border q-mr-xl mobile2" style="width: 209px">
    <div class="row col-3 justify-center mt">
      <q-file
        borderless
        v-model="img"
        class="col-md-10 q-pt-lg"
        type="file"
        label="Adicionar Imagem"
      />
    </div>
    <div class="row q-ma-lg justify-center"></div>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";

export default {
  props: {
    uuid: String,
    upar: Number,
  },
  emits: ["atualizar"],
  setup(props, { emit }) {
    const store = useStore();

    const imageUrl = ref("");
    const img = ref(null);

    let onUpload = async () => {
      await store.dispatch("fer/uploadImagem", {
        uuid: props.uuid,
        imagem: imageUrl.value,
      });
      imageUrl.value = "";
      img.value = null;
      atualizar();
    };
    let atualizar = async (atualizar) => {
      emit("atualizar", atualizar);
    };

    watch(
      () => img.value,
      () => {
        if (img.value == null) {
          return;
        }
        let fileReader = new FileReader();

        fileReader.readAsDataURL(img.value);
        fileReader.addEventListener("load", () => {
          imageUrl.value = fileReader.result;
        });
      }
    );

    watch(
      () => props.upar,
      () => {
        onUpload();
      }
    );

    return {
      imageUrl,

      onUpload,
      atualizar,
      img,
    };
  },
};
</script>

<style scoped>
.border {
  border: 1px solid #b4b4b4 !important;
  border-radius: 5px;
}

.mt {
  margin-top: 50px;
  margin-left: 15px;
}

@media (max-width: 1343px) {
  .mobile2 {
    width: 100% !important;
    margin: 0 auto;
  }
}
</style>
